import { Avatar, AvatarSize, Box, Text, theme } from '@bechtel/gds';
import { getNameInitials } from '@bechtel/ht-clients-common';
import { User, UserProject } from '@bechtel/ht-types';
import React, { useMemo, useState } from 'react';
import { AvatarRegularStyled } from './styled';
export interface UserPhotoProps {
  imageUrl: string;
  size: AvatarSize;
  fontSize?: string;
  user?: User | UserProject;
  backgroundColor?: string | undefined;
}

const UserPhoto: React.FC<UserPhotoProps> = ({ imageUrl, size, user, fontSize, backgroundColor }) => {
  const [error, setError] = useState<boolean>(false);
  const handleImageError = () => {
    setError(true);
  };
  const bgColor = useMemo(() => {
    const colorCodes = [
      theme.colors.blue[100],
      theme.colors.red[100],
      theme.colors.green[100],
      theme.colors.orange[100],
      theme.colors.grey[100],
      theme.colors.yellow[100],
      theme.colors.purple[100],
    ];

    const random = Math.floor(Math.random() * colorCodes.length);
    return colorCodes[random];
  }, []);
  return (
    <Box>
      {imageUrl && !error ? (
        <AvatarRegularStyled
          onError={handleImageError}
          hasImageUrl={imageUrl ? true : false}
          size={size}
          src={imageUrl}
        />
      ) : (
        <Avatar
          size={size}
          style={{
            border: `1px solid ${theme.colors.grey[200]}`,
            backgroundColor: backgroundColor ? backgroundColor : `${bgColor}`,
          }}
        >
          {user && user?.firstName && user?.lastName && (
            <Text weight="550" size={fontSize || '300'}>
              {getNameInitials(user?.firstName, user?.lastName)}
            </Text>
          )}
        </Avatar>
      )}
    </Box>
  );
};

export default UserPhoto;
